import { useCallback, useEffect, useState } from 'react';
import { licencaApi, type EstadoLicenca } from './licencaApi';

const INTERVALO_REVALIDACAO_MS = 10 * 60 * 1000; // 10 min — o servidor cacheia, é leve

export function useLicenca() {
  const [estado, setEstado] = useState<EstadoLicenca | null>(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState<string | null>(null);

  const recheck = useCallback(async () => {
    setCarregando(true);
    setErro(null);
    try {
      const e = await licencaApi.recheck();
      setEstado(e);
    } catch (err) {
      setErro(err instanceof Error ? err.message : 'Falha ao consultar licença');
    } finally {
      setCarregando(false);
    }
  }, []);


  useEffect(() => {
    let ativo = true;
    // No mount, força um recheck — não confia no cache do processo principal.
    // Garante que ao abrir o app a UI reflita o que o servidor diz agora,
    // mesmo se o último check ficou ruim por queda de rede no boot.
    licencaApi
      .recheck()
      .then((e) => {
        if (ativo) setEstado(e);
      })
      .catch((err) => {
        if (ativo) setErro(err instanceof Error ? err.message : 'Falha ao consultar licença');
      })
      .finally(() => {
        if (ativo) setCarregando(false);
      });

    const id = setInterval(() => {
      licencaApi
        .status()
        .then((e) => ativo && setEstado(e))
        .catch(() => undefined);
    }, INTERVALO_REVALIDACAO_MS);

    return () => {
      ativo = false;
      clearInterval(id);
    };
  }, []);

  return { estado, carregando, erro, recheck };
}
